// auth-init.guard.ts
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

export const authInitGuard = async () => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  console.log('🔐 AuthInit Guard - Starting');

  try {
    // Wait for any redirect operations to complete
    console.log('🔐 Handling redirect promise...');
    await msalService.instance.handleRedirectPromise();
    
    const accounts = msalService.instance.getAllAccounts();
    console.log('🔐 Found accounts:', accounts.length);
    
    if (accounts.length === 0) {
      console.log('🔐 No accounts found, redirecting to login');
      router.navigate(['/']);
      return false;
    }

    // Set active account if not already set
    if (!msalService.instance.getActiveAccount()) {
      msalService.instance.setActiveAccount(accounts[0]);
    }

    console.log('🔐 User authenticated:', accounts[0].username);
    return true;
  } catch (error) {
    console.error('🔐 AuthInit Guard - Error:', error);
    router.navigate(['/']);
    return false;
  }
};